import Typography from '@components/atoms/Typography';
import AdvantagesSection from '@components/molecules/AdvantagesSection';
import Message from 'types/Message';
import { FormattedMessage } from 'utils/intl';

import { Item } from './StaticPageFirstSection.types';
import classes from './StaticPageFirstSection.module.scss';

type Props = {
  title: Message;
  description?: Message;
  items: Item[];
  centerItemDescription?: boolean;
  size?: 'md' | 'lg';
};

const StaticPageFirstSection = ({
  title,
  description,
  items,
  centerItemDescription,
  size = 'md',
}: Props): JSX.Element => (
  <>
    {!!description && (
      <div className={classes.columns}>
        <Typography variant="h1" renderAs="div" className={classes.title}>
          {title}
        </Typography>
        <Typography className={classes.secondHeader} variant="h2" renderAs="div">
          {description}
        </Typography>
      </div>
    )}
    <AdvantagesSection
      className={description ? classes.advantageSection : undefined}
      title={!description ? title : undefined}
    >
      {items.map(({ description: itemDescription, icon, id }) => (
        <AdvantagesSection.Item
          key={id}
          size={size}
          objectFit="cover"
          description={<FormattedMessage {...itemDescription} />}
          icon={icon}
          centerDescription={centerItemDescription}
          center={false}
        />
      ))}
    </AdvantagesSection>
  </>
);

export default StaticPageFirstSection;
